interface HeaderSectionProps {
  label?: string;
  title: string;
  subtitle?: string;
}

export function HeaderSection({ label, title, subtitle }: HeaderSectionProps) {
  return (
    <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
      {label ? (
        <div className="text-gradient_green mb-4  uppercase tracking-wider text-sm">
          {label}
        </div>
      ) : null}
      <h2 className="font-heading text-3xl md:text-4xl lg:text-[44px] font-bold tracking-tight">
        {title}
      </h2>
      {subtitle ? (
        <p className="mt-6 text-balance text-lg leading-relaxed text-muted-foreground max-w-2xl">
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
